import { z } from "zod";
import {
    AccountingLedgerBasis,
    AccountingLedgerStatus,
} from "@common/types/domains/accounting/ledger";

export const LEDGER_NAME_MAX_LENGTH = 255;

export const accountingLedgerBasisSchema = z.nativeEnum(AccountingLedgerBasis);

const optionalBooleanQuerySchema = z
    .union([
        z.boolean(),
        z.enum(["true", "false"]).transform((value) => value === "true"),
    ])
    .optional();

export const getLedgersByEntityIdsQuerySchema = z.object({
    entityIds: z.array(z.coerce.number()).max(100),
    includeArchived: optionalBooleanQuerySchema,
});

export const getLedgersForEntityQuerySchema = z.object({
    includeArchived: optionalBooleanQuerySchema,
    includeHasJournalEntries: optionalBooleanQuerySchema,
});

export const updateLedgerBodySchema = z
    .object({
        name: z.string().trim().min(1).max(LEDGER_NAME_MAX_LENGTH).optional(),
        isPrimary: z.boolean().optional(),
    })
    .refine((body) => body.name !== undefined || body.isPrimary !== undefined, {
        message: "At least one field must be provided",
    });

export const setLedgerStatusBodySchema = z.object({
    status: z.nativeEnum(AccountingLedgerStatus),
});

export const duplicateLedgerBodySchema = z.object({
    name: z.string().trim().min(1).max(LEDGER_NAME_MAX_LENGTH),
});
